module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Grater-fd15f5a2f130cd74ccde701d5316d56e.svg";